


// --- urlSyncHelper.js ---

import { useEffect } from 'react';
import { updateUrlParams } from './urlUpdaterHelper';


let zoomListener = null;
let dragListener = null;


export const setupMapListeners = (map) => {
  
  if (!map) return;

  const updateUrlWithMapState = () => {
    const center = map.getCenter();
    const z = map.getZoom();
    updateUrlParams({
      lat: center.lat().toFixed(6),
      lng: center.lng().toFixed(6),
      z
    });
  };

  //console.log('Add listeners');
  zoomListener = map.addListener('zoom_changed', updateUrlWithMapState);
  dragListener = map.addListener('dragend', updateUrlWithMapState);
};

export const teardownMapListeners = () => {
  if (zoomListener) {
    window.google.maps.event.removeListener(zoomListener);
    zoomListener = null;
  }
  if (dragListener) {
    window.google.maps.event.removeListener(dragListener);
    dragListener = null;
  }
};


const useUrlSync = ({ mapRef, mapReady, activeOverlayPlanId, rotation, okayToUpdateURLInt }) => {

  useEffect(() => {
    return () => {
      teardownMapListeners();  // Clean up on unmount
    };
  }, []);


  // Sync selected plan and rotation to URL
  useEffect(() => {

    if (!okayToUpdateURLInt) return;

    updateUrlParams({
      p: activeOverlayPlanId,
      //r: rotation != null ? rotation.toFixed(1) : undefined  // Somewhere along the line we stopped using this...
    });


  }, [activeOverlayPlanId, rotation, okayToUpdateURLInt]);
};

export default useUrlSync;


